import React from 'react';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function Unauthorized() {
  const navigate = useNavigate();
  const { userArea } = useAuth();

  const handleGoBack = () => {
    if (userArea) {
      navigate(`/${userArea}`);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-red-900 to-orange-900 flex items-center justify-center p-4">
      <div className="max-w-md w-full">
        <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-8 text-center">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-red-500/20 rounded-full mb-6">
            <ShieldAlert className="w-10 h-10 text-red-400" />
          </div>
          
          <h1 className="text-3xl font-bold text-white mb-4">
            Acceso No Autorizado
          </h1>
          
          <p className="text-gray-300 mb-8">
            No tienes permisos para acceder a esta área del dashboard.
          </p>
          
          <button
            onClick={handleGoBack}
            className="inline-flex items-center space-x-2 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-6 py-3 rounded-lg font-semibold hover:from-blue-600 hover:to-purple-600 transition-all duration-200"
          >
            <ArrowLeft className="w-5 h-5" />
            <span>Volver a mi área</span>
          </button>
        </div>
      </div>
    </div>
  );
}
